import graphql from 'babel-plugin-relay/macro';

const FinalizeUploadMutation = graphql`
  mutation FinalizeUploadMutation($input: FinalizeUploadInput!) {
    finalizeUpload(input: $input) {
      success
      message
      jobRequest {
        dbId
        id
        status
        uploadStatus
      }
    }
  }
`;

export default FinalizeUploadMutation;
